var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeWidth: 2,
    transform: "translate(-445.05 -385.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m477.609 442.424v-.218c0-.289-.005-.572-.01-.848-.029-1.551-.051-2.775.839-3.4a3.463 3.463 0 0 1 2.007-.43c.4 0 .817.021 1.259.043.465.023.945.047 1.426.047a5.427 5.427 0 0 0 3.991-1.3c1.273-1.262 1.784-3.349 1.766-7.2v-.218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.512 427.3h2.588c3.913 0 4.062-.017 4.136-.027a3.047 3.047 0 0 0 2.346-1.669 2.6 2.6 0 0 0 -.228-2.3c-.625-1.009-1.458-2.5-2.264-3.947-.665-1.19-1.293-2.314-1.818-3.2-.214-.922-.407-1.814-.594-2.677-1.369-6.3-2.45-11.287-8.851-15.158a22.327 22.327 0 0 0 -11.427-3.062 21 21 0 0 0 -15.472 6.323c-3.615 3.9-5.276 9.239-4.8 15.436.572 7.472 2.514 9.435 4.393 11.334 3.2 3.231 3.163 5.208 3.108 8.483-.008.465-.016.956-.016 1.48v.218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.47 419.154.488-1.184 3.145-1.379v-3.721l-3.145-1.379-.488-1.183 1.247-3.2-2.632-2.631-3.2 1.247-1.184-.488-1.378-3.145h-3.723l-1.378 3.145-1.184.488-3.2-1.247-2.631 2.631 1.247 3.2-.488 1.183-3.145 1.379v3.721l3.145 1.379.488 1.184-1.247 3.2 2.631 2.631 3.2-1.247 1.184.488 1.378 3.145h3.722l1.378-3.145 1.184-.488 3.2 1.247 2.632-2.631z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.465 408.566a6.164 6.164 0 1 0 6.165 6.165 6.172 6.172 0 0 0 -6.165-6.165z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMind);
export default __webpack_public_path__ + "static/media/mind.8fdf7d7d32eb220b619d7836bbd7b949.svg";
export { ForwardRef as ReactComponent };